import React from 'react'
import styled from 'styled-components'
import { backgroundColors } from 'config'

const LeftAlignRadioV2 = ({
  icon,
  name,
  selected,
  onClick,
  value,
  className,
  ...props
}) => (
  <WrapperBg
    bgColor={backgroundColors.normalLeft}
    className={`${className} ${selected && 'selected'}`}
    {...props}>
    <Wrapper onClick={onClick} className={selected && 'selected'}>
      <TopBox>
        {icon}
        <Input
          bgColor={backgroundColors.normalLeft}
          id={`opt-${value}-${name}`}
          name={name}
          checked={selected}
          onChange={onClick}
        />
      </TopBox>
      <Title>{name}</Title>
    </Wrapper>
  </WrapperBg>
)

export default LeftAlignRadioV2

const WrapperBg = styled.div`
  height: 105px;
  width: 105px;
  border: 1px solid #ececec;
  flex-grow: 1;
  cursor: pointer;

  &:hover,
  &.selected {
    border: none;
    background: ${({ bgColor }) => bgColor};
    padding: 1px;
  }
`

const Wrapper = styled.div`
  display: flex;
  padding: 12px;
  width: 100%;
  height: 100%;
  flex-direction: column;
  justify-content: space-between;
  align-items: flex-start;
  flex: 1 0 0;
  align-self: stretch;
  background: #fff;

  &.selected {
    background: linear-gradient(
        0deg,
        rgba(147, 193, 62, 0.1) 0%,
        rgba(147, 193, 62, 0.1) 100%
      ),
      #fff;
  }
`

const TopBox = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  align-self: stretch;
`

const Title = styled.span`
  color: #3e3e3e;
  font-feature-settings: 'liga' off, 'clig' off;
  font-family: Nunito;
  font-size: 14px;
  font-style: normal;
  font-weight: 600;
  line-height: 18px; /* 128.571% */
`

const Input = styled.input.attrs({
  type: 'radio',
})`
  display: block;
  width: 20px !important;
  height: 20px !important;
  border: none !important;
  position: relative;
  z-index: 1;
  cursor: pointer;

  &::before {
    content: '';
    display: block;
    position: absolute;
    inset: 0;
    border-radius: 999px;
    border: 1px solid #ececec;
    background: #f9f9f9;
    z-index: 2;
  }

  &::after {
    content: '';
    display: block;
    position: absolute;
    width: 10px;
    height: 10px;
    top: 5px;
    left: 5px;
    border-radius: 999px;
    background: #fff;
    z-index: 3;
    display: none;
  }

  &:checked {
    &::before {
      background: ${({ bgColor }) => bgColor};
      border: none;
    }
    &::after {
      display: block;
    }
  }
`



// WEBPACK FOOTER //
// ./src/components/LeftAlignRadioV2/index.js